export default __webpack_public_path__ + "static/media/co2_green_light.a6a01f8e.svg";